import React from 'react';

import { EngineStuff } from '../components/engine-stuff';
import Engine from '../engine';

class DummyContext implements EngineStuff {
  engine!: Engine;
  parent = null;
  parentInstanceUUID = '';
}

const EngineContext = React.createContext<EngineStuff>(new DummyContext());

export default EngineContext;
